<mat-form-field [ngClass]="{'flex-input':is_flex}">
  <mat-label>Suche</mat-label>
  <input matInput [(ngModel)]="search_input"
         (keyup)="onKeyUp($event)">
</mat-form-field>
<button mat-mini-fab color="primary" (click)="doSearch()">
  <mat-icon aria-label="suchen">search</mat-icon>
</button>
